import { type MaybeRefOrGetter, computed, toValue } from 'vue'
import type { LocaleMessages } from '@/ui-core/plugin/config'
import { useConfig } from './use-config'

export const useLocaleMessage = (
  keyRaw: MaybeRefOrGetter<keyof LocaleMessages>
) => {
  const { config } = useConfig()

  const message = computed(() => {
    const key = toValue(keyRaw)
    const { messages, locale } = config.value

    return messages[locale]?.[key] || messages.en[key]
  })

  return message
}
